module.exports={


	                 /* SmartReads Server URL'S
                   ================================== */
         URL:'https://config-services.smartreads.in/noton/graphql',
         Auth:'https://config-services.smartreads.in/identity/oauth/token'

} 
